module.exports = __webpack_public_path__ + "img/game5.2.0706bcea.png";